export default [
    'uploadconfig@/api/v2/sts/uploadconfig',
    'OSSUPLOAD imageUpload@maxSize:2G|accept:jpeg,jpg,png,gif'
]